import { render } from "./gang-change-ppp2-tp.vue?vue&type=template&id=1bc6f872"
import script from "./gang-change-ppp2-tp.vue?vue&type=script&lang=js"
export * from "./gang-change-ppp2-tp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__